import React from 'react';

const ScvComputer = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      width={props.width || 16}
      height={props.height || 14}
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3513_43781)">
        <path
          d="M6.37575 7.14123C6.532 7.29748 6.78525 7.29748 6.9415 7.14123L7.22425 6.85848C7.3805 6.70223 7.3805 6.44898 7.22425 6.29273L6.33125 5.39998L7.224 4.50698C7.38025 4.35073 7.38025 4.09748 7.224 3.94123L6.94125 3.65848C6.785 3.50223 6.53175 3.50223 6.3755 3.65848L4.917 5.11698C4.76075 5.27323 4.76075 5.52648 4.917 5.68273L6.37575 7.14123ZM8.776 6.85873L9.05875 7.14148C9.215 7.29773 9.46825 7.29773 9.6245 7.14148L11.083 5.68298C11.2393 5.52673 11.2393 5.27348 11.083 5.11723L9.6245 3.65873C9.46825 3.50248 9.215 3.50248 9.05875 3.65873L8.776 3.94148C8.61975 4.09773 8.61975 4.35098 8.776 4.50723L9.66875 5.39998L8.776 6.29298C8.61975 6.44923 8.61975 6.70248 8.776 6.85873ZM15.6 11H9.5385C9.52 11.4952 9.17075 11.8 8.72 11.8H7.2C6.73275 11.8 6.3745 11.3632 6.38075 11H0.4C0.18 11 0 11.18 0 11.4V11.8C0 12.68 0.72 13.4 1.6 13.4H14.4C15.28 13.4 16 12.68 16 11.8V11.4C16 11.18 15.82 11 15.6 11ZM14.4 1.79998C14.4 1.13998 13.86 0.599976 13.2 0.599976H2.8C2.14 0.599976 1.6 1.13998 1.6 1.79998V10.2H14.4V1.79998ZM12.8 8.59998H3.2V2.19998H12.8V8.59998Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3513_43781">
          <rect width="16" height="12.8" fill="currentColor" transform="translate(0 0.599976)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ScvComputer;
